import { useAppConfig } from "@/api/app-config/useAppConfig";

import type { IUseAdminPanelEnabledReturn } from "./types";

// NOTE: Reads isAdminPanelEnabled from the public /app-config endpoint, no auth required.
export const useAdminPanelEnabled = (): IUseAdminPanelEnabledReturn => {
  const { data, isLoading } = useAppConfig();
  return {
    isAdminPanelEnabled: data?.isAdminPanelEnabled ?? false,
    isLoading,
  };
};
